import { Component, OnInit } from '@angular/core';
import { DriverService } from '../../driver.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Event as NavigationEvent } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
@Component({
  selector: 'app-driver-history',
  templateUrl: './driver-history.component.html',
  styleUrls: ['./driver-history.component.scss']
})
export class DriverHistoryComponent implements OnInit {
id: string;
did: number;

idandDate: any = {};
distance: any = {};
date: Date = new Date();
g: any;
h: any;
isLoad = false;
p = 1;
spin: boolean;
n: number;
orderDetail: any = [];
public href = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private driverService: DriverService,
    private route: ActivatedRoute
  ) {
    this.href = this.router.url;
    this.id = this.href.split('/')[3];
    // tslint:disable-next-line:radix
    this.did = parseInt(this.id);
    // console.log('id passing for driver', this.did);
   }

  ngOnInit() {
    this.getHistory();
  }

  fun(a) {
    this.n = a;
    // console.log('nnnnnnnnnnnnnn' + this.n);
    this.getOrderDetail();
  }



  getOrderDetail() {
    this.driverService.GETOrderDetailByOrderId(this.did).subscribe(Response => {
      this.orderDetail = Response;

      console.log('orderDetaillllllllllllllllll', this.orderDetail);
    });
  }
  getHistory() {
    this.driverService.GETOrderHistory(this.did, this.g, this.h).subscribe(Response => {
      this.idandDate = Response;
      this.distance = Response['Orders'];
      this.spin = true;
      console.log('Orders', this.distance);
      console.log('New Method data', this.idandDate);
    });
  }
}
